export default __webpack_public_path__ + "static/media/Featured.3eb3453b.jpg";